export default "__VITE_ASSET__C5KLTe0k__"